import { StandardEvents } from '@shopify/events';

const setCount = count => {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-bb-cart-count]').forEach(element => {
    element.textContent = String(count);
    element.closest('a').setAttribute('aria-label', `View shopping bag, ${count} items`);
  });
};
let revision = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const current = ++revision;
  event.promise?.then(({ cart, detail }) => {
    if (current === revision) setCount(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => { /* Horizon handles cart errors in the cart interface. */ });
});
window.addEventListener('pageshow', async event => {
  if (!event.persisted) return;
  const current = ++revision;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    if (current === revision) setCount(cart.item_count);
  } catch { /* A normal page load will refresh the server-rendered count. */ }
});
